import React from "react";

let _ID = 0;
const nextId = () => `gcheck-${++_ID}`;

export const GradientCheck = ({ size = 18, className = "" }) => {
  const id = React.useMemo(nextId, []);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`shrink-0 ${className}`}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#A8FF00" />
          <stop offset="55%" stopColor="#00FFB7" />
          <stop offset="100%" stopColor="#00EFFF" />
        </linearGradient>
      </defs>
      <path
        d="M4 12.5L9.5 18L20 6"
        stroke={`url(#${id})`}
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default GradientCheck;
